export default {
  dbi_store_rank_visualis_card_title_single: 'Rank Trend',
  dbi_store_rank_visualis_card_title_multipe: 'Markets Counts Distribution',
  dbi_store_rank_tables_search_placeholder: 'Search any date, like 2022-04-04',
  dbi_store_rank_top_free: 'Top Free',
  dbi_store_rank_top_free_10: 'Top Free(#1-10)',
  dbi_store_rank_top_grossing: 'Top Grossing',
  dbi_store_rank_top_paid: 'Top Paid',
  dbi_store_rank_top_popular: 'Top Popular',
  dbi_store_rank_top_new_free: 'Top New Free',
  dbi_store_rank_top_new_paid: 'Top New Paid',
  dbi_top_rank_wechat_popularity: 'Top Popular',
  dbi_top_rank_wechat_bestseller: 'Best Selling',
  dbi_top_rank_wechat_most_played: 'Most Played',
  dbi_top_rank_wechat_popularity_30d_avg: 'Top Popular 30D Avg',
  dbi_top_rank_wechat_bestseller_30d_avg: 'Best Selling 30D Avg',
  dbi_top_rank_wechat_most_played_30d_avg: 'Most Played 30D Avg',
  dbi_top_rank_wechat_popularity_wechat: 'WeChat Top Popular',
  dbi_top_rank_wechat_bestseller_wechat: 'WeChat Best Selling',
  dbi_top_rank_wechat_most_played_wechat: 'WeChat Most Played',
  dbi_top_rank_douyin_popularity: 'Top Popular',
  dbi_top_rank_douyin_bestseller: 'Best Selling',
  dbi_top_rank_douyin_fresh_game: 'New Release',
  dbi_top_rank_douyin_popularity_30d_avg: 'Top Popular 30D Avg',
  dbi_top_rank_douyin_bestseller_30d_avg: 'Best Selling 30D Avg',
  dbi_top_rank_douyin_fresh_game_30d_avg: 'New Release 30D Avg',
  dbi_top_rank_douyin_popularity_douyin: 'Douyin Top Popular',
  dbi_top_rank_douyin_bestseller_douyin: 'Douyin Best Selling',
  dbi_top_rank_douyin_fresh_game_douyin: 'Douyin New Release',
  dbi_wechat_top_for_day: 'Top for {dayNum} days',
  dbi_wechat_new_entry: 'New Entry',
  dbi_wechat_gravity_engine: 'Gravity Engine',
  dbi_wechat_sorted_by_rank: '#rank',
  dbi_store_rank_top_sellers: 'Top Sellers',
  dbi_store_rank_most_played: 'Most Played',
  dbi_store_rank_new_and_trending: 'New and Trending',
  dbi_store_rank_top_wish_lists: 'Top Wishlists',
  dbi_store_rank_best_rated: 'Best Rated',
  dbi_store_rank_mini_game_wechat_detail: 'Mini-game Ranking WeChat_Detail',
  dbi_store_rank_mini_game_douyin_detail: 'Mini-game Ranking Douyin_Detail',

  dbi_store_rank_best_selling: 'Best Selling',
  dbi_store_rank_most_downloaded: 'Most Downloaded',
  dbi_store_rank_new_games: 'New Games',
  dbi_store_rank_coming_soon: 'Coming Soon',
  dbi_store_rank_indies_games: 'Indies Games',
  dbi_store_rank_free_to_play: 'Free To Play',
  dbi_store_rank_ps5_most_downloaded: 'PS5 Most Downloaded',
  dbi_store_rank_ps4_most_downloaded: 'PS4 Most Downloaded',
  dbi_store_rank_vr_games: 'VR Games',
  dbi_store_rank_new_release: 'New Release',
  dbi_store_rank_upcoming: 'Upcoming',
  dbi_store_rank_best_sellers: 'Best Sellers',

  dbi_store_rank_no_data_under_current_selections:
    'No data under current selectios.',
  dbi_store_rank_last_updated_on: 'Last updated on {date}.',
  dbi_store_rank_no_data_only_daily: 'Daily granularity data only.',
  dbi_store_rank_mobile_global_region: 'Mobile Global/Region',
  dbi_store_rank_all_top_charts: 'All Top Charts',
  dbi_store_rank_wechat_games: 'WeChat Games',
  dbi_store_rank_douyin_games: 'Douyin Games',
  dbi_store_rank_global_compare: 'Global Compare',
  dbi_store_rank_mobile_top_more_title: 'Top Charts Detail',

  dbi_store_rank_mobile_top_title_metric_tips:
    'Items are listed in descending order by this metric defaultiy.Please select items for selected information only.Sources: {topName} .Learn More',
  dbi_store_rank_sectional_title_metric_tips:
    'The numbers in the table represent the number of countries where the game has entered the top {rangeName} of the rankings.',
  dbi_store_rank_current_order_desc_sectional_title_metric_tips:
    'Items are listed in descending order of the number of countries.',
  dbi_store_rank_current_order_asc_sectional_title_metric_tips:
    'Items are listed in ascending order of the number of countries.',
  dbi_store_rank_mobile_top_title_tips1:
    'Free Top is the list of most downloaded free apps on App Store.',
  dbi_store_rank_mobile_top_title_tips2:
    'Revenue Top is the list of App Store apps with the highest revenue.',
  dbi_store_rank_mobile_top_title_tips3:
    'Paid Chart is a list of the most downloaded paid apps on the App Store.',
  dbi_store_rank_mobile_top_title_tips4:
    'Free Chart is the list of the most downloaded free apps on Google Play.',
  dbi_store_rank_mobile_top_title_tips5:
    'Revenue Chart is a list of the highest-grossing apps within Google Play apps.',
  dbi_store_rank_mobile_top_title_tips6:
    'Paid Charts is the list of the most downloaded paid apps on Google Play.',

  dbi_wechat_popularity_more_title_tips:
    'Calculated based on new user acquisition volume, growth rate, and other metrics (updated daily).',
  dbi_wechat_popularity_30d_avg_more_title_tips:
    'The average ranking on the "Top Popular" list over the past 30 days.',
  dbi_wechat_bestseller_more_title_tips:
    'Calculated based on user activity, effective payment (IAP revenue), and other metrics (updated daily).',
  dbi_wechat_bestseller_30d_avg_more_title_tips:
    'The average ranking on the "Top Best-selling" list over the past 30 days.',
  dbi_wechat_most_played_more_title_tips:
    'Calculated based on user activity, ad monetization performance, and other metrics (updated daily).',
  dbi_wechat_most_played_30d_avg_more_title_tips:
    'The average ranking on the "Top Most Played" list over the past 30 days.',

  dbi_douyin_popularity_more_title_tips:
    'Calculated based on new user acquisition volume, growth rate, and other metrics (updated daily).',
  dbi_douyin_popularity_30d_avg_more_title_tips:
    'The average ranking on the "Top Popular" list over the past 30 days.',
  dbi_douyin_bestseller_more_title_tips:
    'Calculated based on user activity, effective payment (IAP revenue), and other metrics (updated daily).',
  dbi_douyin_bestseller_30d_avg_more_title_tips:
    'The average ranking on the "Best selling" list over the past 30 days.',
  dbi_douyin_fresh_game_more_title_tips:
    'Calculated based on user growth, activity, and early market performance of recently released games (updated daily).',
  dbi_douyin_fresh_game_30d_avg_more_title_tips:
    'The average ranking on the "New Release" list over the past 30 days.',

  dbi_store_rank_mobile_global_compare_country_column_tips:
    'Countries are listed in ascending order by the letter defaultly . If Global or Global except China mainland is selected , the table fixedly shows the first  12 or 11 hot countries.',
  dbi_store_rank_mobile_global_compare_top_20_countries_tips:
    'Top 20 in {num} countries(Selected Countries)',

  dbi_store_rank_weeks: 'Weeks',
  dbi_store_rank_price$: 'Price($)',
  dbi_store_rank_pc_pc_global: 'PC Global',
  dbi_store_rank_pc_steam: 'Steam',
  dbi_store_rank_pc_epic_games: 'Epic Games',
  dbi_store_rank_pc_top_steam_top_sellers_sub_title:
    'Countries Data in the drill-down page',
  dbi_store_rank_pc_peak_today: 'Peak Today',
  dbi_store_rank_pc_top_title_tips_week: 'Number of weeks stayed in top 100.',
  dbi_store_rank_pc_top_title_tips_price: "Today's price of this game.",
  dbi_store_rank_pc_top_title_tips1:
    'Store Rank - Top Sellers: Games sold best on Steam.',
  dbi_store_rank_pc_top_title_tips2:
    'Store Rank - Peak Today: Peak number of players simultaneously in this game in the past 24hours.',
  dbi_store_rank_pc_top_title_tips3:
    'Top sellers list is the list of best-selling games on Epic platform.',
  dbi_store_rank_pc_top_title_tips4:
    'Top Popular list is the list of the most popular games on the Epic platform.',
  dbi_store_rank_pc_top_title_info1:
    'Items are listed in ascending order by this metric defaultly.Please select items for selected information only.Sources: Top Sellers.',
  dbi_store_rank_pc_no_provide_game_details_tips:
    'We don’t provide game details of hardware.',

  dbi_store_rank_console_console_region: 'Console Region',
  dbi_store_rank_console_playstation: 'PlayStation',
  dbi_store_rank_console_pc: 'PC',
  dbi_store_rank_console_pc_steam: 'PC(Steam)',
  dbi_store_rank_console_xbox: 'Xbox',
  dbi_store_rank_console_nintendo: 'Nintendo',
  dbi_store_rank_console_top_title_tips1:
    'Most played is the list of most played games on Xbox.',
  dbi_store_rank_console_top_title_tips2:
    'New release is the list of popular new games on Xbox.',
  dbi_store_rank_console_top_title_tips3:
    'Upcoming is the list of upcoming games on Xbox platform.',
  dbi_store_rank_console_top_title_tips4:
    'Best Sellers is the list of best-selling games on Nintendo platform.',
  dbi_store_rank_console_top_title_tips5:
    'New Release is the list of popular new games on Nintendo platform.',
  dbi_store_rank_console_top_title_tips6:
    'Coming Soon is the list of popular games to be launched on Nintendo platform.',

  dbi_store_rank_single_country_select_footer_btn_text:
    'Go to the Multi-Country Page',

  dbi_store_rank_view_store_rank_top_charts: 'View Store Rank Top Charts',
};
